import React from "react";
import DivTable from "../../components/divTable";
import {faEye} from "@fortawesome/pro-solid-svg-icons";
import {Get} from "../../components/request";
import screens from "../../screens";
import ScreenComponent from "../../components/screenComponent";
import {withRouter} from "react-router-dom";

class Inscriptions extends ScreenComponent {

    constructor(props) {
        super(props);

        this.state = {
            inscriptions: []
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        const {body} = await Get(`/v1/extranet/student/${screens.Inscriptions}`);

        this.setState({
            inscriptions: body
        });
    }

    render() {
        return (
            <section>
                <DivTable columns={{
                    'Année académique': 'AnneeAcademiqueValeur',
                    'Formation': 'DiplomeLibelle',
                    "Niveau d'étude": "NiveauCoursLibelle",
                    "Modalité": "Modalite"
                }}
                          array={this.state.inscriptions}
                          actions={[{href: "inscriptions/:id", icon: faEye, title: "Editer", condition: (item) => process.env.APP_DEPARTEMENT !== "ISFSC" || item.AnneeAcademiqueValeur.includes("2025 - 2026")}]}/>
            </section>
        );
    }
}

export default withRouter(Inscriptions);